import { makeNoteAPIs } from '../../modules/noteAPIFactory'
import { getContractNoteListData } from './mockData'
import type { IContractNote } from '~/types/note/models'

export const {
  getNotes: getContractNotes,
  postNote: postContractNote,
  patchNote: patchContractNote,
  deleteNote: deleteContractNote,
  handlers,
} = makeNoteAPIs<IContractNote>({
  apiPathEntityNamePrefix: 'contract',
  getNoteListDataFn: getContractNoteListData,
})
